import type { Insets } from "./rotated-fit.ts";

export interface ClearViewportRect {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

/** Screen area left visible for the map, inset for panels and a margin. */
export function clearViewportRect(width: number, height: number, insets: Insets, marginPx = 24): ClearViewportRect {
  return {
    left: insets.left + marginPx,
    top: insets.top + marginPx,
    right: width - insets.right - marginPx,
    bottom: height - insets.bottom - marginPx,
  };
}

/** MapLibre `panBy` delta that moves a projected point to the clear viewport centroid. */
export function panOffsetToCenterPoint(px: number, py: number, clear: ClearViewportRect): [number, number] {
  const cx = (clear.left + clear.right) / 2;
  const cy = (clear.top + clear.bottom) / 2;
  return [px - cx, py - cy];
}
